import tw, { styled } from 'twin.macro';

const SidebarListItem = styled.li(tw`mb-4 last-of-type:m-0`);

export default SidebarListItem;
